import { colors, fonts } from './dwa-base'
import buttonTheme from './dwa/button'
import spinnerTheme from './dwa/spinner'
import consumerRTHTableTheme from './dwa/consumerRTHTable'
import consumerRTHGraphTheme from './dwa/consumerRTHGraph'
import type { ComponentThemes, Breakpoints } from './util/types'

const components: ComponentThemes = {
  CardSeparator: {},
  Overlay: {},
  Card: {},
  TextInput: {},
  Button: buttonTheme,
  Spinner: spinnerTheme,
  RadioList: {},
  RadioButton: {},
  ProgressIndicator: {},
  ConsumerRTHTable: consumerRTHTableTheme,
  ConsumerRTHGraph: consumerRTHGraphTheme,
  ListItem: {},
}

export const storybook = {
  base: 'dark',
  brandTitle: 'Diagnostics Web App (Dealer)',

  // appBg: '#292929',
  appContentBg: colors.screen,
  // appContentBg: colors.background,
}

export const breakpoints: Breakpoints = {
  xs: 0,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
}

export default { components, fonts, colors, breakpoints, theme: 'dwa' }
